<template>
  <div class="page">
    <!-- <div class="header-menu">
      <navBar v-model="objSave"></navBar>
    </div> -->
    <div class="page-content">
      <div class="paySucc">
        <div class="paySucc-wrapper">
          <div class="paySucc-info">
            <img src="/static/img/paySucc_icon.png" />
          </div>
          <div class="paySucc-price">
            <div>支付成功</div>
            <div>（已支付￥100元）</div>
          </div>
        </div>
        <div class="paySucc-btn">
          <div>查看订单</div>
          <div>返回首页</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .header-menu {
    background-color: #12a3ff;
  }

  .header-menu header {
    font-size: 0.17rem;
  }

  .paySucc-wrapper {
    background-color: #fff;
    padding: 0.2rem 0;
  }

  .paySucc-info {
    text-align: center;
  }

  .paySucc-info img {
    width: 0.75rem;
    margin: 0 auto;
    vertical-align: middle;
  }

  .paySucc-price {
    text-align: center;
  }

  .paySucc-price > div:first-child {
    color: #06ca53;
    height: 0.45rem;
    line-height: 0.45rem;
    font-size: 0.21rem;
    font-weight: bold;
  }

  .paySucc-price > div:last-child {
    font-size: 0.14rem;
    color: #999;
  }

  .paySucc-btn {
    padding: 1.7rem 0.15rem 0 0.15rem;
  }

  .paySucc-btn > div {
    color: #fff;
    margin-bottom: 0.1rem;
    height: 0.4rem;
    line-height: 0.4rem;
    text-align: center;
    border-radius: 0.04rem;
    cursor: pointer;
  }

  .paySucc-btn > div:first-child {
    background-color: #ff8010;
  }

  .paySucc-btn > div:last-child {
    background-color: #12a3ff;
  }
</style>
<script>
  // import navBar from '../modules/navBar.vue';
  export default {
    data() {
      return {
        objSave: {
          centerTitle: "支付成功",
        },
      };
    },
    components: {
      // navBar
    },
  };
</script>
